/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisableIBANInput
 */
export interface DisableIBANInput {
    /**
     * Payment Account ID
     * @type {string}
     * @memberof DisableIBANInput
     */
    wallet: string;
}

/**
 * Check if a given object implements the DisableIBANInput interface.
 */
export function instanceOfDisableIBANInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "wallet" in value;

    return isInstance;
}

export function DisableIBANInputFromJSON(json: any): DisableIBANInput {
    return DisableIBANInputFromJSONTyped(json, false);
}

export function DisableIBANInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisableIBANInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'wallet': json['wallet'],
    };
}

export function DisableIBANInputToJSON(value?: DisableIBANInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'wallet': value.wallet,
    };
}

